import PropTypes from 'prop-types';
import {Button, Modal} from 'semantic-ui-react';

function ConfirmModal(props) {
  return (
    <Modal
      closeIcon
      closeOnEscape
      closeOnDimmerClick
      open={props.open}
      onClose={props.onCancel}
      size={props.size}
    >
      <Modal.Content>
        <p className='text-large'>{props.content}</p>
      </Modal.Content>
      <Modal.Actions>
        <Button
          positive
          content='بلی'
          onClick={props.onConfirm}
        />
        <Button
          negative
          content='خیر'
          onClick={props.onCancel}
        />
      </Modal.Actions>
    </Modal>
  );
}

ConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  content: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired
};

ConfirmModal.defaultProps = {size: 'small'};

export default ConfirmModal;
